/**
 * Vuely Appliction Components
 */
// qr button to open modal to scan barcode/qr
import BcScanBarcode from "App_components/Modals/BcScanBarcode";

const ApplicationComponents = {
    install(Vue) {
        Vue.component("bcScanBarcode", BcScanBarcode);
    },
};

export default ApplicationComponents;
